import { Module } from 'vuex';
import { mutations } from '@signing-page/session/store/session.mutations';
import { IRootState } from '@signing-page/store/store.ts';
import { actions } from '@signing-page/session/store/session.actions';
import { getters } from '@signing-page/session/store/session.getters';
import { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import { IAuthenticationStepInput } from '@signing-page/authentication/types/authentication-step-input';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';

export const namespace = 'session';

export interface ISessionState {
  token: { jwt: string; exp: number };
  authentication: {
    submittingResponse: boolean;
    steps: IAuthenticationStep[];
    answers: IAuthenticationStepInput[];
  };
  status: EDocumentStatus;
  error: boolean;
  isCorrectPin: boolean;
  sendPinRetryCount: number;
  recipientFirstOpen: boolean;
}

export const state: ISessionState = {
  token: { jwt: '', exp: null },
  authentication: {
    submittingResponse: false,
    steps: [],
    answers: [],
  },
  status: null,
  error: false,
  isCorrectPin: null,
  sendPinRetryCount: 0,
  recipientFirstOpen: false,
};

const namespaced: boolean = true;

export const session: Module<ISessionState, IRootState> = {
  state,
  actions,
  getters,
  mutations,
  namespaced,
};
